import { useState, useMemo, useEffect } from 'react';
import { IRelease } from '../Interfaces/IChangelog';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { ReleaseCard } from './ReleaseCard';
import { useGetUserFullObject } from '../hooks/reactQuerys/UserQueries';
import {
  useGetChangelog,
  useTrackReleaseView,
} from '../hooks/reactQuerys/ChangelogQueries';

export const ChangelogNotifier = () => {
  const userId = localStorage.getItem('idUser');

  const { changelog, isLoadingChangelog } = useGetChangelog();
  const { userFullObject, isLoadingUserFullObject } = useGetUserFullObject(
    Number(userId)
  );
  const { trackReleaseView } = useTrackReleaseView();

  const [showDialog, setShowDialog] = useState(false);

  const unviewedReleases = useMemo(() => {
    if (!changelog || !userFullObject) {
      return [];
    }

    const unviewedReleases = changelog.releases.filter(release => {
      if (!userFullObject.ViewedReleases) {
        return true;
      }

      return !userFullObject.ViewedReleases.some(
        viewedRelease => viewedRelease.idRelease === release.id
      );
    });

    return unviewedReleases;
  }, [changelog, userFullObject]);

  useEffect(() => {
    if (unviewedReleases.length !== 0) {
      setShowDialog(true);
    }
  }, [unviewedReleases]);

  const handleMarkAsViewed = async (releases: IRelease[]) => {
    if (!userId) {
      return;
    }

    try {
      setShowDialog(false);

      await Promise.all(
        releases.map(release =>
          trackReleaseView({
            idRelease: release.id,
            idUser: Number(userId!),
            createdAt: new Date().toISOString(),
          })
        )
      );
    } catch {}
  };

  if (isLoadingChangelog || isLoadingUserFullObject) {
    return null; // Don't show loading indicator for this component
  }

  if (!changelog || !userFullObject) {
    return null;
  }

  return (
    <Dialog
      open={showDialog}
      onClose={() => setShowDialog(false)}
      maxWidth='md'
      fullWidth
    >
      <DialogTitle>
        <Typography variant='h5' component='div' fontWeight='bold'>
          Neue Updates verfügbar
        </Typography>
      </DialogTitle>
      <DialogContent>
        {unviewedReleases.map(release => (
          <ReleaseCard key={release.id} release={release} />
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => handleMarkAsViewed(unviewedReleases)}
          variant='contained'
        >
          Nicht mehr anzeigen
        </Button>
      </DialogActions>
    </Dialog>
  );
};
